import * as React from "react"
import * as ReactDOMServer from "react-dom/server"
import { Link as LinkComponent } from "widgets-for-react"
import { getLangFromUrl, updateUrlLang } from "../../publicSite/utils/history.mod"
import { Link } from "./types.gen"
import { LinkProps } from "./widgets/linkBlock.gen"


export function getClassName<style>(
  options: { style?: style },
  className: keyof style,
  notset: string = ""
): string {
  return String(options && options.style && options.style[className] ? options.style[className] : notset)
}

export function link(
  link: Link,
  style: { classname: string },
  inner: JSX.Element | string,
  onClick?: () => void
): JSX.Element {
  return link.is_link_external || link.target === "_blank" ? (
    <a className={style.classname} target={updateUrlLang(link.target, getLangFromUrl())} rel={link.target === "_blank" ? "noopener" : null} href={link.url} onClick={onClick ? onClick : null}>
      {inner}
    </a>
  ) : (
    <LinkComponent className={style.classname} to={updateUrlLang(link.url, getLangFromUrl())} onClick={onClick ? onClick : null}>
      {inner}
    </LinkComponent>
  )
}

//  This function matches the url of a DrupalLink against a regex that checks if the url that we want to
//  navigat to is on the same host we are curently at, or is only a path so we can use the <Link> component
//  otherwhise, if it isnt a url on our own hostname it returns true and is external.

export const isLinkExternal = (link: string): boolean => {
  let currentUrl = window.location.host
  let pattern = RegExp(`(https?:\/\/(!?${currentUrl}/.*)|^\/.*)`, "gm")
  return !pattern.test(link)
}

// Strip a Drupal link of its domain information so we only have the path left

export const stripUrlToPath = (link: { title: string, url: string }): string => {
  // Previous version of for this method. (adjusted it so filters tags can also be applied. REFR-115)
  // let a = document.createElement("a")
  // a.href = link.url
  // return a.pathname

  let strippedUrl = link.url.replace(`${window.location.origin}`, "")
  return strippedUrl
}

// Create a link from an acf link that checks if it is external, and rewrites the url if needed

export const linkWrapper = (link: { title: string, url: string }): Link => ({
  kind: "link",
  is_link_external: isLinkExternal(link.url),
  target: isLinkExternal(link.url) ? "_blank" : "_self",
  title: link.title,
  url: isLinkExternal(link.url) ? link.url : stripUrlToPath(link),
})

export const parseLinkProps = (link: { title: string, url: string }, description: string, key: number): LinkProps => ({
  key: key.toString(),
  title: link.title,
  text: description ? description : '',
  is_link_external: isLinkExternal(link.url),
  target: isLinkExternal(link.url) ? "_blank" : "_self",
  url: isLinkExternal(link.url) ? link.url : stripUrlToPath(link)
})

export const getFileType = (link: string): string => {
  let ext: string = link.split('.').pop()
  return ext;
}

export function getParameterByName(name: string): string {
  let url = window.location.href
  name = name.replace(/[\[\]]/g, "\\$&");
  let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return '';
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function insertUrlParam(key: string, value: string): void {
  if (history.pushState) {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, value);
    let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
    window.history.pushState({ path: newurl }, '', newurl);
  }
}
export function removeUrlParams(kind: "all" | string): void {
  if (history.pushState) {
    let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname
    if (kind != "all") {
      let searchParams = new URLSearchParams(window.location.search);
      searchParams.delete(kind);
      newurl = newurl + '?' + searchParams.toString();

    }

    window.history.pushState({ path: newurl }, '', newurl);
  }
}

export function convertReactNodeToString(title: string | React.ReactNode): string {
  if (title === undefined) return null;
  if (typeof title === 'string') return title;

  if (typeof title === 'number' || typeof title === 'boolean') {
    return title.toString();
  }

  if (React.isValidElement(title)) {
    let flatTitle: string = ReactDOMServer.renderToStaticMarkup(title);
    flatTitle = flatTitle.replace(/(<([^>]+)>)/ig, "");
    return flatTitle;
  }

  return null;
}


export function removeMatchingPart(str1, str2) {
  if(str1 == undefined || str1 == "") return str2
  if(str2 == undefined || str2 == "") return str1
  const regex = new RegExp(str1, 'g');
  const matchingPart = str2.match(regex);
  const result = str2.replace(regex, '');
  return matchingPart ? matchingPart[0] : '';
}

export let cleanMultipleHttps = (url : string) => {
  if(url == undefined || url == "") return url
  //"https://www.refresco.com/en/https://www.refresco.com/en/press-releases/2581467/".split("https").filter(x => x != "")
  let urlParts = url.split("https").filter(x => x != "")
  if(urlParts.length == 1){
    return url
  }
  let url1 = urlParts[1]
  return `https${url1}`

}